import React from 'react'
import styles from './ChoicesButton.module.css'
import { ChoicesButtonProps } from './types'

export const ChoicesButton = ({
    imageSrc,
    imageAlt = '',
    dataClickLabel,
    onClick,
    selected = false
}: ChoicesButtonProps) => {
    return (
        <button
            className={`${styles.wrapper} ${selected ? styles.selected : ''}`}
            onClick={onClick}
            data-click-label={dataClickLabel}
            type={'button'}
        >
            <img
                src={imageSrc}
                alt={imageAlt}
                className={styles.ChoicesButtonImage}
            />
        </button>
    )
}
